<template>
  <router-view />
</template>

<script lang="ts" setup></script>

<style lang="scss">
  @import './assets/sass/main.scss';
  @import '../node_modules/bootstrap/scss/bootstrap.scss';

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #2c3e50;
    height: 100vh;
    height: 100dvh;
    min-height: 0;
    display: flex;
    overflow: hidden;
    // flex-direction: column;
  }

  .striped:nth-of-type(even) {
    background: rgba(0, 0, 0, 0.05);
  }

  .status-text-size {
    font-size: 12px;
  }

  @media screen and (max-width: 1200px) {
    .col-1,
    .col-2,
    .col-3,
    .col-4,
    .col-5,
    .col-6,
    .col-7,
    .col-8,
    .col-9,
    .col-10,
    .col-11,
    .col-12 {
      padding: 0 12px !important;
    }
  }

  @media screen and (max-width: 930px) {
    .status-text-size {
      font-size: 11px;
    }

    .col-1,
    .col-2,
    .col-3,
    .col-4,
    .col-5,
    .col-6,
    .col-7,
    .col-8,
    .col-9,
    .col-10,
    .col-11,
    .col-12 {
      padding: 0 10px !important;
    }
  }

  @media screen and (max-width: 730px) {
    .status-text-size {
      font-size: 9px;
    }

    .col-1,
    .col-2,
    .col-3,
    .col-4,
    .col-5,
    .col-6,
    .col-7,
    .col-8,
    .col-9,
    .col-10,
    .col-11,
    .col-12 {
      padding: 0 6px !important;
    }
  }

  @media screen and (max-width: 430px) {
    .status-text-size {
      font-size: 7px;
    }

    .col-1,
    .col-2,
    .col-3,
    .col-4,
    .col-5,
    .col-6,
    .col-7,
    .col-8,
    .col-9,
    .col-10,
    .col-11,
    .col-12 {
      padding: 0 3px !important;
    }
  }
</style>
